import request from "@utils/request";

export function getDataHighVolumeUSD(query) {
    return request({
        url: 'alert/data/high-volume-usd',
        method: 'get',
        params: query
    })
}
